
import InfoSliderComponent from "@/components/Shared/ViewResultCard/InfoSlider/InfoSliderComponent";
export default InfoSliderComponent;
